import { Badge } from '@liveauctioneers/hammer-ui-core/badge';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { createImage } from '@liveauctioneers/hammer-ui-core/card/components/createImage';
import { ItemCardNavigationTrigger } from '@/utils/amplitude/analytics';
import { ItemSummary } from '@/types/item/ItemSummary';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useItemCardNavigation } from '@/utils/amplitude/experiments/hooks/useItemCardNavigation';
import CardImage from '@/components/GridItemCard/Card/CardOptions/CategorySearchCards/components/CardImage/CardImage';
import theme from '@liveauctioneers/caterwaul-components/lib/theme/theme';
import TimedBadgeContainer from '@/components/GridItemCard/Card/CardOptions/TimedPlusItemCard/components/TimedBadgeContainer/TimedBadgeContainer';
import useIsWiderThan from '@/hooks/useIsWiderThan';

const MOBILE_IMAGE_QUALITY = 70;
const DESKTOP_IMAGE_QUALITY = 80;

const MOBILE_DIMENSION = 280;
const DESKTOP_DIMENSION = 380;

export const ImageComponent = createImage<ItemSummary & { position: number }>({
    ImageComponent: ({ className, isTimedPlusAuction, itemId, position, promoted }) => {
        const { formatMessage } = useIntl();
        const { onNavigateInitiated } = useItemCardNavigation(itemId);
        const isMobile = !useIsWiderThan(theme.breakpoints.tabletNarrowWidthNum);
        const useSmallerImageQuality = !useIsWiderThan(theme.breakpoints.pageWidthNum);

        const handleMouseHover = (isHovered: boolean) => {
            const itemCard = document.getElementById(`card-${itemId}`);
            if (itemCard) {
                if (isHovered) {
                    itemCard.classList.add('image-hover');
                } else {
                    itemCard.classList.remove('image-hover');
                }
            }
        };

        return (
            <>
                {isTimedPlusAuction && <TimedBadgeContainer itemId={itemId} />}
                {promoted && !isTimedPlusAuction && (
                    <Badge
                        className="absolute left-xs top-xs z-[1]"
                        color="neutral"
                        round
                    >
                        {formatMessage({ id: 'featured' })}
                    </Badge>
                )}
                <div className={cn('overflow-hidden rounded-md border border-border-tertiary', className)}>
                    <CardImage
                        applyDimensionToUrl
                        canShowEasyShipping
                        dimension={useSmallerImageQuality ? MOBILE_DIMENSION : DESKTOP_DIMENSION}
                        enterLinkHoverState={() => handleMouseHover(true)}
                        imageQuality={useSmallerImageQuality ? MOBILE_IMAGE_QUALITY : DESKTOP_IMAGE_QUALITY}
                        isLabeledFavoriteButton
                        isMobile={isMobile}
                        itemId={itemId}
                        lazyLoadImage
                        leaveLinkHoverState={() => handleMouseHover(false)}
                        onNavigate={() => {
                            onNavigateInitiated(ItemCardNavigationTrigger.ImageClick, { position });
                        }}
                        sharpenImage
                    />
                </div>
            </>
        );
    },
});
